import React, { useState, useEffect } from "react";
import { Button, Container, Form, Row, Col, Spinner, Alert } from "react-bootstrap";
import axiosInstance from '../components/AxiosInstance';
import { API_URL } from "../Config";
import { useNavigate } from "react-router-dom";

const MyAccount = () => {
    const [user, setuser] = useState({
        first_name: null,
        last_name: null,
        email: '',
        mobile_number: '',
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
    });
    //const [userData, setuserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setuser((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    useEffect(() => {
        const getUserProfile = async () => {
            try {
                const res = await axiosInstance.get("auth/profile");
                if (res.data && res.data.user) {
                    setuser(res.data.user);  // Adjust based on API structure
                } else {
                    setError('Invalid user data structure.');
                }
                setLoading(false);
            } catch (err) {
                setError("Unable to fetch profile data. Please try again!");
                setLoading(false);
            }
        };
        getUserProfile();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError("");
        setSuccessMessage("");

        try {
            var url = API_URL + "auth/updateprofile";
            const response = await axiosInstance.post(url, user);
            setSuccessMessage(response.data.message);
        } catch (error) {
            // Handle any errors
            if (error.response) {
                // The server responded with an error
                console.error("Error response:", error.response.data);
                setError("An error occurred. Please try again.");

            } else if (error.request) {
                // The request was made but no response was received
                console.error("Error request:", error.request);
                setError("No response from the server. Please try again later.");
            } else {
                // Something else caused the error
                console.error("Error:", error.message);
                setError("An unknown error occurred. Please try again.");
            }
        } finally {
            setIsSubmitting(false);
        }

    };

    const handleCancel = () => {
        navigate("/dashboard");
    }

    if (loading) {
        return (
            <div><br /> <br />
                <br /> <br />
                <Container className="collaborate-section p-4 rounded bg-white">
                    <Row className="justify-content-center">
                        <Col xs="auto">
                            <Spinner animation="border" variant="primary" />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    if (error) {
        return (
            <div><br /> <br />
                <br /> <br />
                <Container className="shadow p-4 rounded bg-white">
                    <Row className="justify-content-center">
                        <Col>
                            <div className="alert alert-danger">{error}</div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    return (
        <div>
            <Container className="collaborate-section rounded" >
                <div className="text-center">
                    <span className="highlight-text">
                        Your account details
                    </span>
                </div>
                {successMessage && <Alert variant="success">{successMessage}</Alert>}
                <br /> <br />
                <Row>
                    <Col></Col>
                    <Col xs={8}>
                        <Form>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridEmail">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter First Name" name="first_name" maxLength={35} value={user.first_name || ''} onChange={handleChange} />
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridPassword">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Last Name" name="last_name" maxLength={20} value={user.last_name || ''} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridEmail">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="text" placeholder="Enter email" name="email" value={user.email || ''} onChange={handleChange} disabled />
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridPassword">
                                    <Form.Label>Mobile Number</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Mobile number" name="mobile_number" value={user.mobile_number || ''} onChange={handleChange} disabled />
                                </Form.Group>
                            </Row>

                            <Form.Group className="mb-3" controlId="formGridAddress1">
                                <Form.Label>Address</Form.Label>
                                <Form.Control type="text" placeholder="1234 Main St" name="address1" value={user.address1 || ''} maxLength={100} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formGridAddress2">
                                <Form.Label>Address 2</Form.Label>
                                <Form.Control type="text" placeholder="Apartment, studio, or floor" name="address2" value={user.address2 || ''} maxLength={100} onChange={handleChange} />
                            </Form.Group>

                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridCity">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control type="text" name="city" value={user.city || ''} onChange={handleChange} />
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridState">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control type="text" name="state" value={user.state || ''} onChange={handleChange} />
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridZip">
                                    <Form.Label>Zip</Form.Label>
                                    <Form.Control type="text" name="zip" value={user.zip || ''} onChange={handleChange} maxLength={6} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="formGridCountry">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control type="text" name="country" value={user.country || ''} onChange={handleChange} />
                                </Form.Group>
                            </Row>
                            <br />
                            <Row className="mb-3">
                                <Form.Group as={Col} className="text-end" controlId="formGridCity">
                                    <Button className="btn-lg" variant="light" type="reset" onClick={handleCancel} >
                                        Cancel Changes
                                    </Button>
                                </Form.Group>
                                <Form.Group as={Col} controlId="formGridCity">
                                    <Button className="btn-lg" variant="primary" type="submit" onClick={handleSubmit} disabled={isSubmitting}>
                                        {isSubmitting ? "Saving Changes..." : "Save Changes"}
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Col>
                    <Col></Col>
                </Row>
            </Container>
        </div >
    );
};

export default MyAccount;